import { Component, OnInit, Output, EventEmitter } from '@angular/core';
import { PartnersService } from '@core/services/partners.service';
import { Filterable } from '@common/utilities/Filterable';
import { PartnerRecord } from '@core/services/data.service';
import { SynchronizationService } from '@core/services/synchronization.service';
import {  } from 'events';
import { ModalService } from '@common/services/modal.service';

@Component({
  templateUrl: './partner-selector.component.html',
  styleUrls: ['./partner-selector.component.scss']
})
export class PartnerSelectorComponent implements OnInit {

  constructor(private psrv: PartnersService, private sync: SynchronizationService, private modal: ModalService) { }

  public partners = new Filterable<PartnerRecord>({ extractor: i => [i.Name, 'K' + i.ID] });

  @Output()
  public onSelected = new EventEmitter<PartnerRecord>();

  ngOnInit(): void {
    this.sync.when(PartnersService).commit(() => this.partners.source = this.psrv.all.filter(i => i.ID > 3));
  }

  public select(partner: PartnerRecord) {
    this.onSelected.emit(partner);
    this.modal.of(this).hide();
  }
}
